import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "label"]

  connect() {
    this.restoreHiddenColumns()
    this.updateHiddenCount()
  }

  toggle(event) {
    const item = event.currentTarget
    const column = item.dataset.column
    const direction = item.dataset.direction
    const cells = document.querySelectorAll(`.col-${column}[data-direction="${direction}"]`)

    cells.forEach(cell => cell.classList.toggle("d-none"))

    const icon = item.querySelector("i")
    icon?.classList.toggle("invisible")

    item.classList.toggle("active")

    this.toggleHiddenColumn(direction, column)
    this.updateHiddenCount()
  }

  toggleHiddenColumn(direction, column) {
    const key = "hiddenColumns"
    const storage = JSON.parse(localStorage.getItem(key)) || []
    const id = `${direction}:${column}`

    if (storage.includes(id)) {
      localStorage.setItem(key, JSON.stringify(storage.filter(i => i !== id)))
    } else {
      localStorage.setItem(key, JSON.stringify([...storage, id]))
    }
  }

  restoreHiddenColumns() {
    const currentDirection = this.getCurrentDirection()
    const hidden = JSON.parse(localStorage.getItem("hiddenColumns")) || []

    this.itemTargets.forEach(item => {
      const column = item.dataset.column
      const direction = item.dataset.direction
      const id = `${direction}:${column}`

      if (hidden.includes(id)) {
        const cells = document.querySelectorAll(`.col-${column}[data-direction="${direction}"]`)
        cells.forEach(cell => cell.classList.add("d-none"))

        const icon = item.querySelector("i")
        icon?.classList.add("invisible")

        item.classList.add("active")
      }
    })
  }

  updateHiddenCount() {
    const currentDirection = this.getCurrentDirection()
    const hidden = JSON.parse(localStorage.getItem("hiddenColumns")) || []

    const count = hidden.filter(id => id.startsWith(`${currentDirection}:`)).length
    this.labelTarget.textContent = count <= 0 ? 'Columns' : `${count} Hidden Column${count !== 1 ? "s" : ""}`
  }

  getCurrentDirection() {
    const path = window.location.pathname
    if (path.includes("/referrals/outbound") || path.includes("/dashboard/outbound")) return "outbound"
    if (path.includes("/referrals/inbound") || path.includes("/dashboard/inbound")) return "inbound"
    return "inbound"
  }
}
